import { pkCheckApi, pkCreateApi, pkRegApi, successCode } from '../api';
import useLocalStore from '../state/useLocalStore';
import useStore from '../state/useStore';
import { IWeb3ChainType } from '../providers/web3Provider/type';
import { Web3Type } from '../config/type';

export default function useTomoUserInfo() {
  const { user, setUser, deviceId, setDeviceId } = useLocalStore();

  const evmAddress = user?.v2Address;
  const solAddress = user?.solanaAddress;
  const tonAddress = user?.tonAddress;
  const tonPublicKey = user?.tonPublicKey;

  const btcAddress = {
    bitcoinP2PkhAddress: user?.bitcoinP2pkhAddress,
    bitcoinP2ShAddress: user?.bitcoinP2shAddress,
    bitcoinP2TrAddress: user?.bitcoinP2trAddress,
    bitcoinP2WpkhAddress: user?.bitcoinP2wpkhAddress,
  };
  const getAddressByChain = function({
    chain,
    options,
  }: {
    chain: IWeb3ChainType | undefined;
    options?: {
      btcType: 'pkh' | 'sh' | 'tr' | 'wpkh';
    };
  }) {
    switch (chain?.type) {
      case Web3Type.EVM:
        return evmAddress;
      case Web3Type.SOL:
        return solAddress;
      case Web3Type.BTC:
        if (options?.btcType == 'sh') {
          return btcAddress.bitcoinP2ShAddress;
        }
        if (options?.btcType == 'tr') {
          return btcAddress.bitcoinP2TrAddress;
        }
        if (options?.btcType == 'wpkh') {
          return btcAddress.bitcoinP2WpkhAddress;
        }
        return btcAddress.bitcoinP2PkhAddress;
      default:
        return undefined;
    }
  };
  return {
    getAddressByChain,
    userInfo: user,
    setUserInfo: setUser,
    deviceId,
    evmAddress,
    solAddress,
    tonAddress,
    tonPublicKey,
    btcAddress,
    generateDeviceId: async () => {
      if (deviceId) {
        return deviceId;
      }
      const generate = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(
          c
        ) {
          const r = (Math.random() * 16) | 0,
            v = c === 'x' ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        });
      };
      const id = generate();
      console.log('generate deviceId', id);
      //generate pubkey
      const v2PkRegRes = await pkRegApi(id);
      if (v2PkRegRes.code != successCode) {
        throw new Error('Failed to generate pubkey');
      }
      const pubkey = v2PkRegRes.data.pubkey;
      //create pubkey
      const v2PkCreateRes = await pkCreateApi({
        device_no: id,
        pubkey: pubkey,
      });
      if (v2PkCreateRes.code != successCode) {
        throw new Error('Failed to create pubkey');
      }
      //check
      const checkRes = await pkCheckApi(id);
      if (checkRes.code != successCode) {
        throw new Error('Failed to check pubkey');
      }
      if (!checkRes.data.is_exists) {
        throw new Error('Pubkey is not existed');
      }
      setDeviceId(id);
      return id;
    },
  };
}
